import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'

export const slimBannerFragment = gql`
  fragment SlimBannerFragment on SlimBannerRecord {
    id
    text
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
    image {
      id
      alt
      url
      width
      height
    }
  }
`

export const zoomMasonryFragment = gql`
  ${responsiveImageFragment}
  fragment ZoomMasonryFragment on ZoomMasonryRecord {
    id
    images {
      id
      scale
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
      videoPreview 
      fullVideo
    }
  }
`

export const mediaCarouselFragment = gql`
  ${responsiveImageFragment}
  fragment MediaCarouselFragment on MediaCarouselRecord {
    id
    isVertical
    slides {
      id
      text
      linkVideo
      link {
        id
        label
        link
        externalLink
      }
      image {
        id
        responsiveImage(
          imgixParams: { ar: "16:9", fit: crop, w: "2000", fm: webp }
        ) {
          ...ResponsiveImageFragment
        }
      }
      portrait: image {
        id
        responsiveImage(
          imgixParams: { ar: "4:5", fit: crop, w: "2000", fm: webp }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
  }
`

export const textImageBlockFragment = gql`
  ${responsiveImageFragment}
  fragment TextImageBlockFragment on TextImageBlockRecord {
    id
    textHeading
    text
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
    textImage {
      id
      responsiveImage(imgixParams: { auto: compress, q: "60" }) {
        ...ResponsiveImageFragment
      }
    }
    textLink {
      id
      label
      linkUrl
    }
    textVideoLink
    image {
      id
      responsiveImage(imgixParams: { auto: compress, q: "60" }) {
        ...ResponsiveImageFragment
      }
    }
    videoLink
    imageOnTheLeft
    fullwidth
  }
`

export const sectionFragment = gql`
  ${responsiveImageFragment}
  fragment SectionFragment on SectionRecord {
    id
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
    mainMedia {
      id
      videoUrl
      image {
        id
        responsiveImage(imgixParams: { auto: compress, q: "60" }) {
          ...ResponsiveImageFragment
        }
      }
    }
    mainMediaLarger
    pretitle
    title
    subtitle
    description
    topImage {
      id
      alt
      url
      width
      height
    }
    linkUrl
    linkLabel
    backgroundImage {
      id
      responsiveImage(
        imgixParams: { auto: format, q: "60", fit: crop }
      ) {
        ...ResponsiveImageFragment
      }
    }
    leftMedia {
      id
      videoUrl
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
    rightMedia {
      id
      videoUrl
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
    bottomImage {
      id
      responsiveImage(
        imgixParams: { auto: format, q: "60", fit: crop }
      ) {
        ...ResponsiveImageFragment
      }
    }
  }
`

export const centeredMediaBlockFragment = gql`
  ${responsiveImageFragment}
  fragment CenteredMediaBlockFragment on CenteredMediaBlockRecord {
    id
    isLarger
    videoUrl
    image {
      id
      responsiveImage(imgixParams: { auto: compress, q: "60" }) {
        ...ResponsiveImageFragment
      }
    }
  }
`

export const videoBlockFragment = gql`
  fragment VideoBlockFragment on VideoBlockRecord {
    id
    videoPreview
    videoFull
  }
`

export const cardCarouselFragment = gql`
  ${responsiveImageFragment}
  fragment CardCarouselFragment on CardCarouselRecord {
    id
    verticalRatio
    slides {
      id
      linkVideo
      linkVideoPreview
      image {
        id
        responsiveImage(
          imgixParams: { ar: "16:9", fit: crop, w: "2000", fm: webp }
        ) {
          ...ResponsiveImageFragment
        }
      }
      portrait: image {
        id
        responsiveImage(
          imgixParams: { ar: "4:5", fit: crop, w: "2000", fm: webp }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
  }
`

export const timelineBlockFragment = gql`
  ${responsiveImageFragment}
  fragment TimelineBlockFragment on TimelineBlockRecord {
    id
    title
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
    timelineList {
      id
      year
      description
      topLeftImage {
        id
        custom: responsiveImage(
          imgixParams: { fm: webp, q: "60", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
      }
      topLeftImageText
      rightImage {
        id
        custom: responsiveImage(
          imgixParams: { fm: webp, q: "60", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
      }
      rightImageText
      bottomLeftImage {
        id
        custom: responsiveImage(
          imgixParams: { fm: webp, q: "60", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
      }
      leftPng {
        id
        custom: responsiveImage(
          imgixParams: { fm: webp, q: "60", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
      }
      rightPng {
        id
        custom: responsiveImage(
          imgixParams: { fm: webp, q: "60", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
      }
      sideImage {
        id
        custom: responsiveImage(
          imgixParams: { fm: webp, q: "60", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
      }
      sideImageDown
    }
  }
`
